(function() {
    'use strict';

    /**
     * 
     */
    angular.module('asebiol').controller('reportCtrl', [ '$scope', '$attrs', 'reportService', function($scope, $attrs, reportService) {

        $scope.getData = function(reportType) {
            var data;
            switch (reportType) {
            case REPORT_TYPE.REPORT_OC:
                data = reportService.firstReport();
                break;
            default:
                data = reportService.defaultReport();
                break;
            }

            $scope.resolveData(data);

        };

        $scope.resolveData = function(data) {
            $scope.labels = data.labels;
            $scope.series = data.series;
            $scope.data = data.data;

        };

        $scope.getData(eval('REPORT_TYPE.' + $attrs.report));
        $scope.onClick = function(points, evt) {
            console.log(points, evt);
        };

    } ]);

}());